import { EntityType } from "@mapmycustomers/shared/enum";
import Route, {
  RouteCompanyStop,
  RouteManualStop,
  RoutePersonStop,
} from "@mapmycustomers/shared/types/entity/Route";

const buildStopsFromRoute = (
  route: Route
): Array<RouteCompanyStop | RouteManualStop | RoutePersonStop> => {
  const stopTime = route.stopTime ?? [];
  return stopTime.filter(
    (stop): stop is RouteCompanyStop | RouteManualStop | RoutePersonStop =>
      stop.entity === EntityType.COMPANY ||
      stop.entity === EntityType.PERSON ||
      stop.entity === null
  );
};

export default buildStopsFromRoute;
